var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.83954V16.8395C8 17.37 8.21071 17.8787 8.58579 18.2538C8.96086 18.6288 9.46957 18.8395 10 18.8395H18C18.5304 18.8395 19.0391 18.6288 19.4142 18.2538C19.7893 17.8787 20 17.37 20 16.8395V8.08154C20 7.8151 19.9467 7.55135 19.8433 7.30578C19.7399 7.06022 19.5885 6.83778 19.398 6.65154L16.083 3.40954C15.7094 3.0442 15.2076 2.8396 14.685 2.83954H10C9.46957 2.83954 8.96086 3.05025 8.58579 3.42532C8.21071 3.8004 8 4.30911 8 4.83954V4.83954Z",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.8395V20.8395C16 21.37 15.7893 21.8787 15.4142 22.2538C15.0391 22.6288 14.5304 22.8395 14 22.8395H6C5.46957 22.8395 4.96086 22.6288 4.58579 22.2538C4.21071 21.8787 4 21.37 4 20.8395V9.83954C4 9.30911 4.21071 8.8004 4.58579 8.42532C4.96086 8.05025 5.46957 7.83954 6 7.83954H8",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.336f5e3283a6964cdec5d272d68f1b7c.svg";
export { ForwardRef as ReactComponent };